import { REF_UI } from "@/data/ui/manasikRefUi";
import { HAJJ_UI } from "@/data/ui/hajjTimelineUi";
import { AUDIOBOOK_UI } from "@/data/audiobookI18n";
import { getStations, getTopics } from "@/lib/manasikContent";

const DAY_ORDER = ["8", "9", "10", "tasyrik", "wada"];
const DAY_KEY = { "8": "day8", "9": "day9", "10": "day10", tasyrik: "daytasyrik", wada: "daywada" };
const STATUS_KEY = { rukun: "statusRukun", wajib: "statusWajib", sunnah: "statusSunnah" };

// Chapter index of a Hajj timeline day (chapters = reference topics, then the days).
export const hajjChapterIndex = (day) => getTopics().length + DAY_ORDER.indexOf(day);

// Chapters mirror the PDF handbook: reference topics, then the Hajj days.
// Each chapter is a list of short TTS segments (Arabic duas stay in Arabic, then the meaning).
export function buildChapters(tc, content = { topics: getTopics(), stations: getStations() }) {
  const topics = content.topics.map((t) => ({
    id: `topic-${t.id}`,
    title: tc(t.title),
    segments: [
      `${tc(t.title)}. ${tc(t.intro)}`,
      ...t.sections.map((s) => `${tc(s.h)}. ${tc(s.b)}`),
      ...(t.evidence ? [`${tc(REF_UI.evidenceLabel)}: ${tc(t.evidence)}`] : []),
    ],
  }));
  const days = DAY_ORDER.map((d) => {
    const segments = [];
    content.stations.filter((s) => s.day === d).forEach((s) => {
      segments.push(`${tc(s.title)} — ${tc(HAJJ_UI[STATUS_KEY[s.status]])}. ${s.body.map((b) => tc(b)).join(" ")}`);
      if (s.arabic) segments.push(s.arabic);
      if (s.arabic && s.dua) segments.push(tc(s.dua));
      if (s.evidence) segments.push(`${tc(HAJJ_UI.evidenceLabel)}: ${tc(s.evidence)}`);
    });
    return { id: `hajj-${d}`, title: `${tc(AUDIOBOOK_UI.hajjPart)} — ${tc(HAJJ_UI[DAY_KEY[d]])}`, segments };
  });
  return [...topics, ...days];
}
